<template>
  <b-modal ref="modal" v-bind="$attrs" v-on="$listeners">
    <slot />

    <template v-slot:modal-header-close>
      <span href="#close">
        <SvgIcon name="components/close" width="16" height="16" />
      </span>
    </template>

    <template v-slot:modal-footer="{ ok, cancel }">
      <slot name="footer" :ok="ok" :cancel="cancel" />
    </template>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue/src/components/modal/modal";
import SvgIcon from "vue-svgicon/dist/components/svgicon.common";

import "../../icons/components/close";

export default {
  components: {
    BModal,
    SvgIcon
  },
  inheritAttrs: false,

  methods: {
    show() {
      this.$refs["modal"].show();
    },
    hide() {
      this.$refs["modal"].hide();
    },
    toggle() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["modal"].toggle("#toggle-btn");
    }
  }
};
</script>

<style lang="scss">
.modal {
  &-header {
    padding: 1.25rem 1rem 1rem 1rem;

    &,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: $font-size-base;
    }

    .close {
      padding: 0;
      margin: 0;
      background-color: transparent;
      border: none;

      &:focus {
        outline: 0;
      }
    }
  }

  &-body {
    padding: 1.5rem 1rem;
    font-size: $font-size-base;
  }

  &-footer {
    padding: 0 (1rem - 0.25rem) 1rem (1rem - 0.25rem);

    .btn {
      flex-grow: 1;
      flex-basis: 0;
    }
  }
}

@include media-breakpoint-up(sm) {
  .modal {
    &-content {
      box-shadow: $modal-content-box-shadow-sm-up;
    }

    &-header {
      padding: 1.5rem $modal-inner-padding;
      border-bottom: transparent;
      align-items: center;

      &,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: $font-size-lg;
      }
    }

    &-body {
      padding: 0 $modal-inner-padding 2rem $modal-inner-padding;

      .form-group {
        margin-bottom: 0;
      }
    }

    &-footer {
      padding: 0 ($modal-inner-padding - 0.25rem) 2.0625rem
        ($modal-inner-padding - 0.25rem);

      > * {
        margin-top: 0;
      }
    }
  }
}
</style>
